import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import CSSModules from 'helpers/CSSModulesUtil'

import UserItem from './UserItem'
import ValueItem from './ValueItem'
import DefaultItem from './DefaultItem'

import styles from './styles.scss'

const placeHolder = <DefaultItem/>

class UserSelection extends Component {
  valueRenderer = ({ name }) => <ValueItem name={name}/>
  optionRenderer = ({ name, image }) => <UserItem name={name} image={image}/>

  render() {
    return (
      <Select
        {...this.props}
        placeholder={placeHolder}
        optionRenderer={this.optionRenderer}
        valueRenderer={this.valueRenderer}
        labelKey='name'
        valueKey='username'
        styleName='userSelection'
      />
    )
  }
}

const withStyle = CSSModules(styles)
export default withStyle(UserSelection)
